module.exports = " <div class=p-v> <div class=md-list-item-text> <p ng-class=reviewTVM.courseText(course) class=\"text-color no-margin exo\"> <strong>{{ course.nameCourse }}</strong> </p> <p ng-class=reviewTVM.courseText(course) class=\"text-sm no-margin proxima\"> Profesor {{ course.nameTeacher }} </p> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/consolidationCP/teachingDevelopment/listTeacherJobsView/jobs/list-data-course.html
// module id = 658
// module chunks = 0